// extracted by mini-css-extract-plugin
export default {"legendIndicator":"sra-z","legendNew":"tra-z"};